import React, { useState, useEffect } from 'react';
import {
    ListGroup,
    ListGroupItem,
    ListGroupItemHeading,
    Label,
    Input,
} from 'reactstrap';
import { Col, Row } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import './SubviewPlanDetails.scss';
import { formatCost } from '../../../../util/format';
import CommonButton from '../../../../../Common/Button/Button';

const BenefitDetailsList = ({ details }) => (
    <ListGroup className="mx-0 detail-list">
        {details.map((detail, index) => {
            let bgColorDiv = 'muted';
            if (index % 2) {
                bgColorDiv = 'light';
            }

            if (isEmpty(detail.description)) {
                return (
                    <ListGroupItem color={bgColorDiv} key={index}>
                        <ListGroupItemHeading className="text-dark detail-header">
                            {detail.name}
                        </ListGroupItemHeading>
                    </ListGroupItem>
                );
            }

            return (
                <ListGroupItem color={bgColorDiv} key={index}>
                    <ListGroupItemHeading className="text-dark detail-header">
                        {detail.name}
                    </ListGroupItemHeading>

                    <ul className="benefits">
                        {detail.description.split('|  |').map((desc, index) => {
                            return (
                                !isEmpty(desc.trim()) && (
                                    <li
                                        className="benefit-desc"
                                        key={`benefit_${index}`}
                                    >
                                        {desc}
                                    </li>
                                )
                            );
                        })}
                    </ul>
                </ListGroupItem>
            );
        })}
    </ListGroup>
);

const SubviewPlanDetails = ({
    title,
    details,
    displayView,
    comparableView,
    benefitSummaryLinks,
}) => {
    const [filePath, setFilePath] = useState('');
    const languageDropdownId = `languageSelect-${displayView}-${title}`;

    return (
        <div>
            {!comparableView && (
                <div className="mt-3 mx-md-2 plan-details">
                    <Row>
                        <Col sm="12">
                            <h6>Summary of benefits and coverage:</h6>
                        </Col>
                    </Row>
                    <Row className="summary">
                        <Col sm="8" className="mb-sm-2">
                            <div className="language-input">
                                <Label for={languageDropdownId}>
                                    Choose Language
                                </Label>
                                <Input
                                    type="select"
                                    defaultValue="placeholder"
                                    id={languageDropdownId}
                                    onChange={(e) => {
                                        setFilePath(
                                            benefitSummaryLinks[e.target.value]
                                                .url
                                        );
                                    }}
                                >
                                    <option value="placeholder" disabled>
                                        Select...
                                    </option>
                                    {benefitSummaryLinks?.map((link, index) => (
                                        <option
                                            key={`language_${index}`}
                                            value={index}
                                        >
                                            {link.language}
                                        </option>
                                    ))}
                                </Input>
                            </div>
                        </Col>
                        <Col sm="4" className="mb-sm-2 px-0">
                            <div className="download-btn">
                                <CommonButton
                                    disabled={isEmpty(filePath)}
                                    href={filePath}
                                    target="_blank"
                                    className="btn-secondary"
                                >
                                    Download
                                </CommonButton>
                            </div>
                        </Col>
                    </Row>
                </div>
            )}
            <BenefitDetailsList details={details} />
        </div>
    );
};

export { SubviewPlanDetails as default, BenefitDetailsList };
